import { STATUS } from "@/constant/statusConstants";

const PlayerTypeInitialValues = (showData) => ({
  sport_id: showData?.data?.sport_id || "",
  code: showData?.data?.code || "",
  name: showData?.data?.name || "",
  status: showData?.data?.status || STATUS.INACTIVE,
});

export default PlayerTypeInitialValues;
